// import React from 'react';
// import local from 'services/localization/local';
// import { LoadingPage } from 'shared';

// export default function AuthLoader() {
//   return (
//     <div id="main-layout">
//       <LoadingPage centerElement={local.signingIn} />
//     </div>
//   );
// }

import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import local from 'services/localization/local';
import { LoadingPage } from 'shared';

export default function AuthLoader() {
  return (
    <BrowserRouter>
      <div id="main-layout">
        <LoadingPage centerElement={local.signingIn} />
      </div>
    </BrowserRouter>
  );
}
